<!--
    课程商品-课程商品
    作用：课程商品列表
    组件:旧版本
-->
<template>
  <div v-loading="loading">
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="'新增'"
      title=""
      api="/api/course/commodities"
      @create="addCreate">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="340"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <div>
                <el-button class="opt-btn" size="small" @click="editShelf(scope.row.id, scope.row.status == 1 ? 2 : 1)">{{scope.row.status_text === '上架' ? '下架' : '上架'}}</el-button>
                <el-button class="opt-btn" size="small" @click="editSee(scope.row)">查看</el-button>
                <el-button class="opt-btn" size="small" @click="editUpdate(scope.row)">编辑</el-button>
                <el-button v-if="scope.row.has_order" class="opt-btn" size="small" @click="editCopy(scope.row.id)">复制</el-button>
                <el-button v-else class="opt-btn" size="small" @click="editDelete(scope.row.id)">删除</el-button>
              </div>
              <div>
                <el-button class="opt-btn" size="small" @click="editClass(scope.row)">课时编辑</el-button>
                <el-button class="opt-btn" size="small" @click="editLink(scope.row, 'buyStatistics')">购买统计</el-button>
                <el-button class="opt-btn" size="small" @click="editLink(scope.row, 'timeStatistics')">耗课统计</el-button>
                <el-button class="opt-btn" size="small" @click="schoolChoseShow(scope.row)">开放校区</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <!--    新增商品-->
    <el-dialog
      :title="formData.title"
      :visible.sync="formDialogVisible"
      width="1000px"
    >
      <el-form
        :rules="rules"
        ref="form"
        :model="formData"
        label-width="150px"
        :disabled="formData.title === '查看详情'"
        :class="{'dis-event': formData.title === '查看详情', 'dis-some': formData.editId && formData.hasOrder}"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="*商品封面图" class="headimgurl">
              <AppUploadScale
                v-model="formData.cover"
                class="form_img"
                :common="true"
                :icon="true"
                @on-success="getCoverUrl"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品视频介绍" class="headimgurl">
              <AppUploadVideo
                v-model="formData.video"
                class="form_img"
                :common="true"
                :icon="true"
                :is-delete="true"
                @on-delete="deleteVideo"
                @on-success="getVideoUrl"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品视频介绍链接" prop="video">
              <el-input v-model="formData.video" placeholder="链接" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model="formData.name"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="商品简介" prop="introduction">
          <el-input
            :autosize="{ minRows: 2, maxRows: 20}"
            v-model="formData.introduction"
            type="textarea"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品详情"
          prop="detail"
          class="area-detail allow-some">
          <AppTextArea
            :value="formData.detail"
            :init-visible="formDialogVisible"
            :is-disable="false"
            @change="changeFn"
          />
        </el-form-item>

        <el-form-item label="商品类别" prop="commodity_tag_id">
          <el-select v-model="formData.commodity_tag_id" placeholder="请选择">
            <el-option
              v-for="state in commodity_tag_list"
              :key="state.id"
              :label="state.name"
              :value="state.id"
            />
          </el-select>
        </el-form-item>

        <el-row type="flex">
          <el-form-item label="所属类别" prop="stage_tag_id">
            <el-select v-model="formData.stage_tag_id" placeholder="请选择">
              <el-option
                v-for="state in stage_tag_list"
                :key="state.id"
                :label="state.name"
                :value="state.id"
              />
            </el-select>

          </el-form-item>

          <el-form-item prop="subject_tag_id" label-width="10px">
            <el-select v-model="formData.subject_tag_id" placeholder="请选择">
              <el-option
                v-for="state in subject_tag_list"
                :key="state.id"
                :label="state.name"
                :value="state.id"
              />
            </el-select>
          </el-form-item>
        </el-row>

        <el-row type="flex" class="allow-some">
          <el-form-item label="开放校区" prop="school_ids">
            <el-button @click="() => schoolChoseShow()">选择校区</el-button>
            <span style="color: red;">已选{{schoolChose.choseLen}}个</span>
          </el-form-item>

          <el-form-item label="制作校区" prop="make_school_id" label-width="204px">
            <el-select filterable v-model="formData.make_school_id" placeholder="请选择">
              <el-option
                v-for="state in school_list"
                :key="state.value"
                :label="state.name"
                :value="state.value"
              />
            </el-select>
          </el-form-item>
        </el-row>

        <el-row type="flex" align="middle">
          <div class="el-form-item" style="width: 150px;">线下课时单价（/课时/次）</div>

          <el-form-item label="原价" prop="offline_price" label-width="50px" style="white-space: nowrap;">
            <el-input v-model="formData.offline_price" type="number" @change="changeForm('offline_price', 0, null, 'offline_discount_price')"></el-input>
            金币
          </el-form-item>

          <el-form-item label="优惠价" prop="offline_discount_price" label-width="100px" style="white-space: nowrap;margin-left: 100px;">
            <el-input v-model="formData.offline_discount_price" type="number" @change="changeForm('offline_discount_price', 0, 'offline_price')"></el-input>
            金币
          </el-form-item>
        </el-row>

        <el-row type="flex" align="middle">
          <div class="el-form-item" style="width: 150px;">线上课时单价（/课时/学生/次）</div>

          <el-form-item label="原价" prop="online_price" label-width="50px" style="white-space: nowrap;">
            <el-input v-model="formData.online_price" type="number" @change="changeForm('online_price', 0, null, 'online_discount_price')"></el-input>
            金币
          </el-form-item>

          <el-form-item label="优惠价" prop="online_discount_price" label-width="100px" style="white-space: nowrap;margin-left: 100px;">
            <el-input v-model="formData.online_discount_price" type="number" @change="changeForm('online_discount_price', 0, 'online_price')"></el-input>
            金币
          </el-form-item>
        </el-row>

        <el-row type="flex" align="middle" class="allow-some">
          <el-form-item label="线下起始购买次数" prop="min_offline_num" label-width="200px">
            <el-input style="width: 202.16px;" v-model="formData.min_offline_num" type="number" min="0" max="999999" @input="limitNum('off')"></el-input>
          </el-form-item>

          <el-form-item label="线上起始购买次数" prop="min_online_num" label-width="200px">
            <el-input style="width: 202.16px;" v-model="formData.min_online_num" type="number" min="0" max="999999" @input="limitNum('on')"></el-input>
          </el-form-item>
        </el-row>

        <el-radio-group v-model="formData.status">
          <el-radio :label="1">立即上架</el-radio>
          <el-radio :label="2">手动上架</el-radio>
        </el-radio-group>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <template v-if="formData.title === '查看详情'">
          <el-button type="primary" @click="formDialogVisible = false">确 定</el-button>
        </template>
        <template v-else>
          <el-button @click="formDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmit">确 定</el-button>
        </template>
      </span>
    </el-dialog>

    <!--    开放校区 -> 校区列表 -->
    <el-dialog
      :title="schoolChose.title"
      :visible.sync="schoolChose.show"
      width="1471px"
      @close="openSchoolChose"
    >
      <div v-loading.lock="schoolChose.loading">
        <el-row type="flex" justify="space-between">
          <el-form
            ref="school_chose_form"
            :model="schoolChose.formData"
            :inline="true"
            size="small"
            @keydown.enter.native="() => schoolChoseFlashData(1, true)"
          >
            <el-form-item>
              <el-button :type="isSchoolChoseAll ? 'primary' : ''" @click="schoolChoseAll">全选</el-button>
            </el-form-item>

            <el-form-item>
              <div
                style="float: left;line-height: 32px; color: #303133;"
              >校区分类: &nbsp;</div>

              <TypeSelect
                type="school_category"
                :rootCatalog="'校区分类'"
                :rootTitle="'校区分类编辑'"
                :data.sync="typeSelectDataMe"
                @onTypeSelect="obj => schoolChose.formData.school_category_id = obj.id"
              />
            </el-form-item>

            <el-form-item
              v-if="schoolChose.commodities_id !== ''"
            >
              <el-select
                v-model="schoolChose.formData['equal[open_school_commodities_select]']"
                placeholder="请选择"
                clearable
              >
                <el-option
                  value="1"
                  label="已选"
                ></el-option>
                <el-option
                  value="0"
                  label="未选"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select
                v-model="schoolChose.formData['equal[school_is_master]']"
                placeholder="请选择"
                clearable
              >
                <el-option
                  value="1"
                  label="总校"
                ></el-option>
                <el-option
                  value="0"
                  label="分校"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-input
                v-model="schoolChose.preSelect.value"
                placeholder="请输入内容"
                clearable
                @change="schoolChosePreChange"
                @input="schoolChosePreChange"
              >
                <el-select
                  clearable
                  v-model="schoolChose.preSelect.attr"
                  slot="prepend"
                  placeholder="请选择"
                  :style="{ width: selectWidth }"
                >
                  <el-option
                    v-for="(item, index) in schoolChose.preSelect.option"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>

            <el-button
              icon="el-icon-search"
              size="small"
              class="list-header__button"
              @click="() => schoolChoseFlashData(1, true)"
            />
          </el-form>

          <div>
            <el-button size="small" type="primary" @click="schoolChoseSubmit">确 认</el-button>
            <el-button size="small" @click="schoolChose.show = false">取 消</el-button>
          </div>
        </el-row>

        <el-table
          class="school-chose"
          :data="schoolChose.tableData"
          @selection-change="schoolChoseSelect"
          @select="schoolChoseSelectUser"
          row-key="id"
          ref="schoolChoseTabel"
        >
          <el-table-column
            type="selection"
            width="55"
            reserve-selection
          >
          </el-table-column>

          <el-table-column
            v-for="column in schoolChose.tableColumn"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />

          <el-table-column
            label="课件权限"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.clients_course_make_status === 1">启用</span>
              <span v-else>禁用</span>
              <el-switch
                :value="scope.row.clients_course_make_status === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchCourseMake(scope.row)"/>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="320px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="doubleYun(scope.row)"
              >擎想系统课件</el-button>

              <el-popover
                placement="left"
                trigger="hover"
              >
                <div class="flex-column">
                  <el-button
                    size="small"
                    @click="setWechat(scope.row)"
                  >小程序</el-button>
                  <el-button
                    v-if="scope.row.school_is_master === 1 && !scope.row.as_agent"
                    size="small"
                    @click="setting(scope.row)"
                  >设置</el-button>
                  <el-button
                    size="small"
                    @click="getAuthClass(scope.row)"
                  >授权课包</el-button>
                  <el-button
                    size="small"
                    @click="moreMove(scope.row.id)"
                  >移动</el-button>

                  <el-button
                    size="small"
                    @click="setMembershipLevels(scope.row)"
                  >设置会员等级</el-button>
                  <el-button
                    size="small"
                    @click="practiceFeeConfiguration(scope.row)"
                  >练习收费配置</el-button>
                </div>

                <el-button style="margin-left: 10px;" slot="reference" size="small">更多</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: 20px;"
          v-if="schoolChose.tableData.length && schoolChose.meta"
          background
          :page-size="10"
          :current-page="schoolChose.meta.current_page"
          layout="prev, pager, next"
          :total="schoolChose.meta.total"
          @current-change="schoolChoseFlashData"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!--    设置-->
    <el-dialog
      :visible.sync="dialogSet.show"
      title="设置"
      width="500px"
    >
      <el-form
        :model="dialogSet.forms"
        label-width="120px"
        v-loading.lock="dialogSet.loading"
      >
        <el-form-item label="升级代理商">
          <el-radio-group v-model="dialogSet.forms.factor">
            <el-radio :label="2">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogSet.show = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitSetting">确 定</el-button>
      </span>
    </el-dialog>

    <!--    关联小程序-->
    <el-dialog
      :visible.sync="dialogWechat.show"
      title="关联小程序"
      width="500px"
    >
      <el-form
        :model="dialogWechat.forms"
        label-width="120px"
        v-loading.lock="dialogWechat.loading"
      >
        <el-form-item label="关联小程序：">
          {{ dialogWechat.forms.text }} {{ dialogWechat.isRelevance ? '（已关联）' : '' }}
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogWechat.show = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitWechat">确 定</el-button>
      </span>
    </el-dialog>

    <!--    授权课包-->
    <el-dialog
      v-if="authClass.show"
      :title="authClass.title"
      :visible.sync="authClass.show"
      center
      width="1471px"
    >
      <AppList
        ref="list"
        :list.sync="authClass.list"
        :is-loading="authClass.loading"
        title=""
        :api="authClass.api"
        :api-type="authClass.api"
        :exit-url="false"
        :page-call="pageCall"
        class="search-fix1"
      >
        <el-row
          slot="search"
          type="flex"
          justify="space-between"
        >
          <AppSearch
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="authClassAttr"
            :search-call="searchCall"
          />

          <el-button type="primary" @click="authClass.show = false">确 认</el-button>
        </el-row>

        <template slot-scope="props">
          <ul v-if="props.listData && props.listData.length" class="goods-ul">
            <li class="goods-li" v-for="item in props.listData" :key="item.id">
              <div class="goods-head pr">
                <img :src="item.image || item.cover || noCover">
                <div v-if="item.video" class="goods-video">
                  <div class="video-btn" @click.stop="showVideo(item.name, item.video)"></div>
                </div>
                <el-checkbox class="select-check" :class="[{aa: item.school_ids.includes(authClass.id)}, authClass.id]" :value="item.school_ids.includes(authClass.id)" @change="val => GoodsCheck(val, item)"></el-checkbox>
              </div>

              <div class="goods-foot flex ac jb">
                <h3 class="goods-title elps">{{item.name}}</h3>
                <el-popover
                  v-if="item.detail && item.introduction"
                  width="212"
                  offset="10"
                  placement="top-start"
                  popper-class="goods-tip-con"
                  trigger="hover"
                >
                  <figure>
                    <h4>主要介绍</h4>
                    <div v-html="item.detail.replace(/iframe/g, 'video').replace(/<video/g, '<video controls').replace(/(<img|<video)/, '$1 style=display:block; ')" class="goods-tip-rec-detail"></div>
                  </figure>
                  <figure>
                    <h4 class="goods-tip-rec-class">课程包简介</h4>
                    <p>{{item.introduction}}</p>
                  </figure>
                  <i slot="reference" class="goods-tip el-icon-warning-outline"/>
                </el-popover>
              </div>
            </li>
          </ul>
          <div v-else class="goods-empty flex dc ac jc">
            <i></i>
            <p>暂无数据</p>
          </div>
        </template>
      </AppList>
    </el-dialog>

    <!--    视频预览-->
    <el-dialog
      :title="videoData.title"
      class="dialog-sp1 dialog-video"
      :visible.sync="videoData.show"
      @opened="videoOpen"
      @close="videoClose"
      width="692px"
    >
      <video ref="ref_video" :src="videoData.src" controls="controls" width="100%"></video>
    </el-dialog>

    <!--    移动-->
    <el-dialog
      title="移动"
      width="460px"
      :visible.sync="moves.show"
    >
      <EleForm
        ref="movesForm"
        :form="moves.form"
        :is-submit="moves.isSubmit"
        @onAttr="onMovesForm"
      ></EleForm>

      <span slot="footer" class="dialog-footer">
        <el-button @click="moves.show = false">取 消</el-button>
        <el-button type="primary" @click="moves.isSubmit = true">确 定</el-button>
      </span>
    </el-dialog>

    <!--设置会员等级-->
    <el-dialog
      v-if="dialogLevel.show"
      title="设置会员等级"
      width="460px"
      :visible.sync="dialogLevel.show"
    >
      <el-form
        ref="form_level"
        :model="form"
        label-width="120px"
        v-loading.lock="dialogLevel.loading"
      >
        <el-form-item label="校区名称:">
          <span>{{dialogLevel.name}}</span>
        </el-form-item>

        <el-form-item label="校区等级:">
          <el-select v-model="dialogLevel.level" placeholder="请选择">
            <el-option
              v-for="item in dialogLevel.levelOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="有效期:" v-if="dialogLevel.level > 0">
          <el-date-picker
            class="level-date-style"
            v-model="dialogLevel.date"
            unlink-panels
            type="daterange"
            :clearable="false"
            :prefix-icon="null"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeLevel"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogLevelSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!--校区练习收费规则配置-->
    <el-dialog
      v-if="dialogFee.show"
      title="校区练习收费规则配置"
      width="460px"
      :visible.sync="dialogFee.show"
    >
      <el-form
        ref="form_fee"
        :model="form"
        label-width="120px"
        v-loading.lock="dialogFee.loading"
      >
        <el-form-item label="校区名称:">
          <span>{{dialogFee.name}}</span>
        </el-form-item>

        <div class="style-fee">
          每人每月收费
          <el-input v-model="dialogFee.coin" @change="dialogFeeInput"/>
          元或金币
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFeeSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import TypeSelect from '../components/typeSelect2';
  import noCover from '@/assets/images/no-cover.png';

  export default {
    name: "GoodsList",
    inject: ['reload'],
    components: {
      TypeSelect,
    },
    data() {
      return {
        list: {},
        loading: false,
        columns: [
          { prop: 'category', label: '类别', formatter: row => row.category === '' ? '--' : row.category },
          { label: '制作校区', formatter: row => (row.make_school && row.make_school.name !== '') ? row.make_school.name : '--' },
          { prop: 'name', label: '商品名称', formatter: row => row.name === '' ? '--' : row.name },
          { prop: 'code', label: '商品编号', formatter: row => row.code === '' ? '--' : row.code },
          { prop: 'course_count', label: '课时总数', formatter: row => row.course_count === '' ? '--' : row.course_count },
          { prop: 'offline_price', label: '线下课时原单价（/课时/次）', formatter: row => row.offline_price === '' ? '--' : row.offline_price },
          { prop: 'offline_discount_price', label: '线下课时优惠单价（/课时/次）', formatter: row => row.offline_discount_price === '' ? '--' : row.offline_discount_price },
          { prop: 'online_price', label: '线上课时原单价（/课时/学生/次）', formatter: row => row.online_price === '' ? '--' : row.online_price },
          { prop: 'online_discount_price', label: '线上课时优惠单价（/课时/学生/次）', formatter: row => row.online_discount_price === '' ? '--' : row.online_discount_price },
          { prop: 'created_at', label: '创建时间', formatter: row => row.created_at === '' ? '--' : row.created_at },
          { prop: 'publish_time', label: '最近上架时间', formatter: row => row.publish_time === '' ? '--' : row.publish_time },
          { prop: 'status_text', label: '上下架状态', formatter: row => row.status_text === '' ? '--' : row.status_text },
        ],

        formData: {},
        formDialogVisible: false,
        form: {
          title: '新增商品',
          name: '', // 姓名
          cover: '', // 封面
          video: '', // 视频
          introduction: '', // 简介
          detail: '', // 详情
          commodity_tag_id: '', // 商品类别
          offline_price: '', // 线下课时原单价
          offline_discount_price: '', // 线下课时优惠单价
          online_price: '', // 线上课时原单价
          online_discount_price: '', // 线上课时优惠单价
          stage_tag_id: '', // 教育阶段
          subject_tag_id: '', // 学科
          status: '', // 立即 | 手动上架

          school_ids: '', // 开放校区
          make_school_id: '', // 制作校区
        },
        rules: {
          name: [
            { required: true, message: '请输入商品名称' },
          ],
          commodity_tag_id: [
            { required: true, message: '请选择商品类别' },
          ],
          stage_tag_id: [
            { required: true, message: '请选择所属类别' },
          ],
          subject_tag_id: [
            { required: true, message: '请选择所属类别' },
          ],
          // school_ids: [
          //   { required: true, message: '请选择开放校区' },
          // ],
          make_school_id: [
            { required: true, message: '请选择制作校区' },
          ],
          offline_price: [
            { required: true, message: '请输入线下课时单价原价' },
          ],
          offline_discount_price: [
            { required: true, message: '请输入线下课时单价优惠价' },
          ],
          online_price: [
            { required: true, message: '请输入线上课时单价原价' },
          ],
          online_discount_price: [
            { required: true, message: '请输入线上课时单价优惠价' },
          ],
        },

        commodity_tag_list: [], // 商品类型
        stage_tag_list: [], // 教育阶段
        subject_tag_list: [], // 学科
        school_list: [], // 快放校区 | 制作校区

        schoolChose: {
          title: '校区列表',
          show: false,
          formData: {},
          preSelect: {
            option: [
              {
                label: '校区名称',
                value: 'like[name]'
              },
              {
                label: '校长名称',
                value: 'like[user_name]'
              },
              {
                label: '校长电话',
                value: 'like[user_mobile]',
                tel: true,
              },
              {
                label: '所属主体名称',
                value: 'like[master_name]'
              },
              {
                label: '所属主体电话',
                value: 'like[master_mobile]',
                tel: true,
              }
            ],
            value: '',
            attr: ''
          },
          loading: false,
          tableData: [],
          tableColumn: [
            {
              prop: 'review_used.name',
              label: '校区名称',
            }, {
              label: '类型',
              formatter: row => (row.school_is_master === 1 ? '总校' : '分校'),
            }, {
              prop: 'vip',
              label: '会员等级',
            }, {
              label: '会员有效期',
              width: '110px',
              formatter: row => {
                let val = '--';

                if (row.vip_start_at) {
                   val = `${row.vip_start_at} - ${row.vip_end_at}`;
                }

                return val;
              },
            }, {
              label: '类型',
              formatter: row => (row.school_is_master === 1 ? '总校' : '分校'),
            }, {
              prop: 'master_info.name',
              label: '所属主体',
            }, {
              label: '状态',
              formatter: row => {
                let val = '--';

                if (row.vip) {
                  val = row.vip_expired ? '已到期' : '进行中';
                }

                return val;
              },
            }, {
              prop: 'review_used.user_name',
              label: '校长',
            }, {
              prop: 'review_used.user_mobile',
              label: '校长电话',
            },
            {
              prop: 'agent_info.agent.name',
              label: '关联代理商',
            },
          ],
          tableChose: [],
          tableCache: [],
          tableOld: [],
          commodities_id: '',
          school_ids: [],
          choseLen: 0,
        },
        schoolChoseCache: {},
        typeSelectDataMe: [
          {
            id: 0,
            name: '所有分类',
            delete: true
          }
        ],

        dialogSet: {
          show: false,
          loading: false,
          userId: '',
          forms: {
            factor: 2,
          }
        },
        dialogWechat: {
          show: false,
          loading: false,
          isRelevance: false,
          forms: {
            id: '',
            mark: 'xiaotianquan',
            text: '校天犬'
          }
        },
        isSchoolChoseAll: false,
        schoolChoseTotal: 0,
        noSchoolChose: [],

        moves: {
          show: false,
          data: [],
          options: [],
          isSubmit: false,
          form: [],
        },
        authClass: {
          title: '授权课包',
          loading: false,
          show: false,
          api: '',
          id: '',
          list: {
            items: []
          },
          per_page: 10,
          page: 1,
          search: [],
        },
        videoData: {
          show: false,
          title: ''
        },
        noCover,

        dialogLevel: {
          show: false,
          loading: false,
          level: 0,
          date: [],
          dates: [],
          created_at: '',
          levelOption: [
            {
              value: 0,
              label: '0 (非会员)',
            },
            {
              value: 1,
              label: '1',
            },
            {
              value: 2,
              label: '2 (未开放)',
              disabled: true,
            },
            {
              value: 3,
              label: '3 (未开放)',
              disabled: true,
            },
          ]
        },

        dialogFee: {
          show: false,
          loading: false,
          coin: 0,
        },
      }
    },
    created () {
      this.$http.get('/api/tags?order[order]=desc&equal[type]=commodity').then(res => this.commodity_tag_list = res.items);

      this.$http.get('/api/tags?order[order]=desc&equal[type]=stage').then(res => this.stage_tag_list = res.items);

      this.$http.get('/api/tags?order[order]=desc&equal[type]=subject').then(res => this.subject_tag_list = res.items);

      this.$http.get('/api/service/operate/school_list?per_page=9999&order[id]=desc').then(res => {
        const _a = [];

        res.items.forEach(item => {
          _a.push({
            value: item.id,
            name: `${item.review_used.name}(${item.review_used.user_mobile})`,
          });
        });

        this.school_list = _a;
      });
    },
    methods: {
      // 显示校区列表
      schoolChoseShow (row) {
        this.schoolChose.show = true;
        this.isSchoolChoseAll = false;
        this.noSchoolChose = [];
        this.schoolChose.tableChose = [];

        if (row) {
          this.schoolChoseCache.id = row.id;
          this.schoolChoseCache.school_ids = row.school_ids;
          this.schoolChose.row = row;
        }

        if (this.schoolChoseCache.id) {
          this.schoolChose.commodities_id = this.schoolChoseCache.id;
          this.schoolChose.school_ids = this.schoolChoseCache.school_ids;
        } else {
          this.schoolChose.commodities_id = '';
          this.schoolChose.school_ids = [];

          if (this.schoolChoseCache.tableChose !== undefined) {
            this.schoolChose.tableCache = Object.assign([], this.schoolChoseCache.tableChose);
          }

          if (this.schoolChoseCache.noSchoolChose !== undefined) {
            this.noSchoolChose = Object.assign([], this.schoolChoseCache.noSchoolChose);
          }

          if (this.schoolChoseCache.isSchoolChoseAll !== undefined) {
            this.isSchoolChoseAll = this.schoolChoseCache.isSchoolChoseAll;
          }
        }

        this.schoolChoseFlashData();
      },

      // 校区列表 - 确认
      schoolChoseSubmit () {
        this.schoolChose.show = false;

        if (this.schoolChose.commodities_id === '') {
          this.schoolChoseCache.tableChose = Object.assign([], this.schoolChose.tableChose, this.schoolChose.tableCache);
          this.schoolChoseCache.noSchoolChose = Object.assign([], this.noSchoolChose);
          this.schoolChoseCache.isSchoolChoseAll = this.isSchoolChoseAll;

          if (this.isSchoolChoseAll) {
            this.schoolChose.choseLen = this.schoolChoseTotal - this.schoolChoseCache.noSchoolChose.length;
          } else {
            this.schoolChose.choseLen = this.schoolChoseCache.tableChose.length;
          }
        }
      },

      // 校区列表 - 选中
      schoolChoseSelect (val) {
        const chose = val.map(item => item.id);

        if (this.isSchoolChoseAll) {
          this.schoolChose.tableOld = this.schoolChose.tableChose;
        }

        this.schoolChose.tableChose = chose;
      },

      // 校区列表 - 手动操作 -> 选出取消勾选的成员
      schoolChoseSelectUser (selection, row) {
        if (this.isSchoolChoseAll) {
          requestAnimationFrame(() => {
            const diffTwo = this.diffTwoArray(this.schoolChose.tableChose, this.schoolChose.tableOld);
            const noSet = new Set(this.noSchoolChose);

            if (this.schoolChose.tableChose.length < this.schoolChose.tableOld.length) {
              diffTwo.forEach(item => {
                noSet.add(item);
              });
            } else {
              diffTwo.forEach(item => {
                noSet.delete(item);
              });
            }

            this.noSchoolChose = [...noSet];

            if (this.schoolChose.commodities_id !== '') {
              this.schoolChose.loading = true;

              this.openSchoolAll();
            }
          });
        } else if (this.schoolChose.commodities_id !== '') {
          this.schoolChose.loading = true;

          if (this.schoolChose.school_ids.includes(row.id)) {
            this.$http.delete('/api/course/commodities/open_school', {
              data: {
                commodities_id: this.schoolChose.commodities_id,
                school_id: row.id,
              }
            }).finally(() => {
              this.schoolChose.loading = false;

              this.schoolChose.school_ids.splice(this.schoolChose.school_ids.indexOf(row.id), 1);

              this.list.items.forEach(item => {
                if (item.id === this.schoolChose.commodities_id) {
                  item.school_ids = this.schoolChose.school_ids;
                }
              });
            });
          } else {
            this.$http.post('/api/course/commodities/open_school_batch', {
              commodities_id: this.schoolChose.commodities_id,
              school_ids: [row.id],
            }).finally(() => {
              this.schoolChose.school_ids.push(row.id);
              this.schoolChose.loading = false;

              this.list.items.forEach(item => {
                if (item.id === this.schoolChose.commodities_id) {
                  item.school_ids = this.schoolChose.school_ids;
                }
              });
            });
          }
        } else {
          const oldLen = this.schoolChose.tableChose.length;

          requestAnimationFrame(() => {
            if (oldLen > this.schoolChose.tableChose.length) {
              this.schoolChose.tableCache.forEach((val, key) => {
                if (val === row.id) {
                  this.schoolChose.tableCache.splice(key, 1);
                }
              });
            }
          });
        }
      },

      // 请求 - 全选
      openSchoolAll () {
        this.$http.post('/api/course/commodities/open_school_all', {
          commodities_id: this.schoolChose.commodities_id,
          exclude: this.noSchoolChose
        })
          .then(res => {
            this.updateLen(this.schoolChose.commodities_id);
          })
          .finally(() => {
          this.schoolChose.loading = false;
          this.schoolChose.needUpdate = true;
        });
      },

      // 校区列表 - 关闭
      openSchoolChose () {
        if (this.schoolChose.needUpdate) {
          this.reload();
        }

        if (this.formData.editId) {
          this.updateLen(this.formData.editId);
        }

        this.schoolChose.formData = {};
        this.schoolChose.preSelect.value = '';
        this.schoolChose.preSelect.attr = '';
        this.schoolChose.needUpdate = false;
      },

      // 校区列表 - 按钮 -> 全选/取消全选
      schoolChoseAll () {
        this.isSchoolChoseAll = !this.isSchoolChoseAll;

        if (this.schoolChose.commodities_id !== '') {
          this.schoolChose.loading = true;
          this.noSchoolChose = [];

          const data = {
            commodities_id: this.schoolChose.commodities_id,
            exclude: []
          };

          if (this.isSchoolChoseAll) {
            this.openSchoolAll();
          } else {
            this.$http.delete('/api/course/commodities/open_school_all', {
              data
            })
              .then(() => {
                this.schoolChose.school_ids = [];
              })
              .finally(() => {
              this.schoolChose.loading = false;
              this.schoolChose.needUpdate = true;
            });
          }
        }

        if (this.isSchoolChoseAll) {
          this.checkSchoolChoseAll();
        } else {
          this.clearSchoolChoseAll();
        }
      },

      // 返回两个数组的差异成员[]
      diffTwoArray (a1, a2) {
        return a1.filter(val => a2.indexOf(val) === -1).concat(a2.filter(val => a1.indexOf(val) === -1));
      },

      // 校区列表 - 表格 -> 全选/取消全选
      checkSchoolChoseAll () {
        this.schoolChose.tableData.forEach(row => {
          if (!this.noSchoolChose.includes(row.id)) {
            this.$refs.schoolChoseTabel.toggleRowSelection(row, true);
          }
        });
      },

      // 校区列表 - 清除全选
      clearSchoolChoseAll () {
        this.$refs.schoolChoseTabel.clearSelection();
        this.noSchoolChose = [];
      },

      // 校区列表 - 请求数据
      schoolChoseFlashData (page = 1, reset = false) {
        this.schoolChose.loading = true

        const pS = this.schoolChose.preSelect;

        if (pS) {
          pS.option.forEach(val => delete this.schoolChose.formData[val.value])
          pS.attr && pS.value && (this.schoolChose.formData[pS.attr] = pS.value)
        }

        this.$http.get(`/api/service/operate/school_list?${this.getURLParam(Object.assign({
          page,
          per_page: 10,
          'order[id]': 'desc',
          open_school_commodities_id: this.schoolChoseCache.id,
        }, this.schoolChose.formData))}`).then(res => {
          this.schoolChose.tableData = res.items;
          this.schoolChose.meta = res.meta;
          this.schoolChose.page = page;

          // 搜索时, 重置勾选
          if (reset && this.schoolChose.commodities_id === '') {
            this.clearSchoolChoseAll();
          }

          this.$nextTick(() => {
            if (this.schoolChose.commodities_id === '') {
              if (this.isSchoolChoseAll) {
                this.checkSchoolChoseAll();
              } else {
                const _chose = Object.assign([], this.schoolChose.tableChose, this.schoolChose.tableCache);

                this.schoolChose.tableData.forEach(row => {
                  this.$refs.schoolChoseTabel.toggleRowSelection(row, _chose.includes(row.id));
                });
              }

              if (!this.schoolChoseTotal && res.meta) {
                this.schoolChoseTotal = res.meta.total;
              }
            } else {
              this.schoolChose.tableData.forEach(row => {
                this.$refs.schoolChoseTabel.toggleRowSelection(row, this.schoolChose.school_ids.includes(row.id));
              });
            }
          });
        }).finally(() => {
          this.schoolChose.loading = false;
        });
      },

      // 参数转成拼在链接上的字符串
      getURLParam (data) {
        return JSON.stringify(data)
          .replace(/:/g, '=')
          .replace(/,/g, '&')
          .replace(/"/g, '')
          .replace(/{/, '')
          .replace(/}/, '');
      },

      // 原价>=优惠价
      changeForm (val, min, max, dis) {
        this.formData[val].length > 9 && (this.formData[val] = this.formData[val].slice(0, 9));
        parseInt(this.formData[val]) < parseInt(min) && (this.formData[val] = min);

        if (dis) {
          parseInt(this.formData[dis]) > parseInt(this.formData[val]) && (this.formData[dis] = this.formData[val]);
        } else if (max) {
          parseInt(this.formData[val]) > parseInt(this.formData[max]) && (this.formData[val] = this.formData[max]);
        }
      },

      // 上架
      editShelf (_id, status) {
        this.$http.patch(`/api/course/commodities/${_id}`, {
          status
        }).then(res => {
          this.$message.success(`${status == 2 ? '下架' : '上架'}成功`);
          this.reload();
        })
      },

      // 删除视频
      deleteVideo() {
        this.formData.video = '';
      },

      // 查看
      editSee (row) {
        this.schoolChose.choseLen = row.school_ids.length;

        this.$http.get(`/api/course/commodities/${row.id}`).then(res => {
          res.data.title = '查看详情'
          this.formData = res.data;
          this.formData.editId = null;
          this.formDialogVisible = true;
        });
      },

      // 编辑
      editUpdate (row) {
        const id = row.id;
        this.schoolChose.choseLen = row.school_ids.length;

        this.$http.get(`/api/course/commodities/${id}`).then(res => {
          res.data.title = '商品编辑'
          this.formData = res.data;
          this.formData.editId = id;
          // this.formData.hasOrder = row.has_order;
          this.schoolChoseCache = {
            id,
            school_ids: row.school_ids
          };
          this.formDialogVisible = true;
        });
      },

      updateLen (id) {
        this.$http.get(`/api/course/commodities?equal[id]=${id}`).then(res => {
          const ids = res.items[0].school_ids;

          this.schoolChose.school_ids = ids;
          this.schoolChose.choseLen = ids.length;
        });
      },

      // 复制
      editCopy (source_commodities_id) {
        this.loading = true;

        this.$http.post(`/api/course/commodities?source_commodities_id=${source_commodities_id}`)
          .then(() => {
            this.$message({
              message: '复制成功',
              type: 'success'
            });
            this.reload();
          })
          .catch(message => this.$message.error(message))
          .finally(() => this.loading = false)
      },

      // 删除
      editDelete (_id) {
        this.$confirm("确定删除该商品？", "删除确认", {
          showCancelButton: true,
          type: "warning",
          confirmButtonText: "删除",
          confirmButtonClass: "el-button--danger"
        })
          .then(() => this.editDeleteConfirm(_id))
          .catch(() => this.loading = false)
      },

      editDeleteConfirm (_id) {
        this.$http.delete(`/api/course/commodities/${_id}`)
          .then(res => {
            this.$alert("删除成功", "删除确认", {
              confirmButtonText: "我知道了",
              type: "success",
              confirmButtonClass: "success"
            });
            this.reload();
          })
          .catch(message => {
            this.$alert(message, "删除确认", {
              confirmButtonText: "我知道了",
              type: "warning",
              confirmButtonClass: "el-button--danger"
            });
          })
          .finally(() => this.loading = false)
      },

      // 课时编辑
      editClass (row) {
        this.$router.push({
          path: '/goods/goodsManageClass',
          query: {
            id: row.id
          }
        })
      },

      // 购买统计 | 耗课统计
      editLink (row, _link) {
        this.$router.push({
          path: `/goods/${_link}`,
          query: {
            id: row.id,
          }
        })
      },

      // 上传图片
      getCoverUrl(url) {
        this.$nextTick(() => {
          this.formData.cover = url;
        });
        this.$forceUpdate();
      },

      // 上传视频
      getVideoUrl(url) {
        this.$nextTick(() => {
          this.formData.video = url;
        });
        this.$forceUpdate();
      },

      // 新增
      addCreate () {
        this.formData.editId = null;
        this.schoolChoseCache = {};
        this.formData = this.form;
        this.schoolChose.choseLen = 0;

        this.formDialogVisible = true;
      },

      // 新增 - 确认
      addSubmit () {
        if (this.loading) {
          return;
        }
        this.loading = true;

        this.$refs.form.validate((valid) => {
          const _data = this.formData;

          !_data.min_offline_num && (_data.min_offline_num = 0);
          !_data.min_online_num && (_data.min_online_num = 0);

          if (!_data.cover) {
            this.$message.error('请选择商品封面图');
            this.loading = false;
            return;
          }

          if (!_data.status) {
            this.$message.error('请勾选立即上架或手动上架');
            this.loading = false;
            return;
          }

          if (valid) {
            _data.school_ids = [];

            if (_data.title === '商品编辑') {
              this.$http.patch(`/api/course/commodities/${_data.editId}`, _data)
                .then(() => {
                  this.addSubmitSuccess();
                })
                .catch((err) => {
                  this.$message.error(err.data.message);
                })
                .finally(() => this.loading = false);
            } else {
              console.log('schoolChoseCache => ', this.schoolChoseCache);
              if (!this.schoolChoseCache.isSchoolChoseAll && !this.schoolChoseCache.tableChose.length) {
                this.$message.error('请选择开放校区');
                this.loading = false;
                return;
              }

              this.$http.post('/api/course/commodities', _data).then(res => {
                const commodities_id = res.data.id;

                if (this.schoolChoseCache.isSchoolChoseAll) {
                  this.$http.post('/api/course/commodities/open_school_all', {
                    commodities_id,
                    exclude: this.schoolChoseCache.noSchoolChose
                  }).then(() => {
                    this.addSubmitSuccess();
                  });
                } else {
                  this.$http.post('/api/course/commodities/open_school_batch', {
                    commodities_id,
                    school_ids: this.schoolChoseCache.tableChose,
                  }).then(() => {
                    this.addSubmitSuccess();
                  });
                }
              })
                .catch(err => {
                  this.$message.error(err.message);
                })
                .finally(() => this.loading = false);
            }
          } else {
            this.loading = false;
          }
        });
      },

      addSubmitSuccess () {
        this.$message.success('保存成功');
        this.formDialogVisible = false;
        this.reload();
      },

      // 商品详情 - 富文本框
      changeFn(data) {
        this.formData.detail = data;
      },

      limitNum (type) {
        let _num = this.formData[`min_${type}line_num`];

        _num > 999999 && (_num = 999999);
        _num < 0 && (_num = 0);

        this.formData[`min_${type}line_num`] = parseInt(_num);
      },

      // 授权双师课件
      double(row) {
        this.$router.push({ path: '/campus/auth', query: { id: row.id } });
      },
      // 擎想系统课件
      doubleYun(row) {
        this.$router.push({ path: '/campus/yun', query: { id: row.id } });
      },
      // 设置
      setting(row) {
        this.dialogSet.show = true;
        this.dialogSet.userId = row.user_id;
      },
      // 升级代理商
      submitSetting() {
        if (this.dialogSet.forms.factor === 1) {
          this.dialogSet.loading = true;

          this.$http
            .post(`/api/service/operate/agent/store/${this.dialogSet.userId}`)
            .then(() => {
              this.$message.success('升级代理商成功！');
              this.schoolChoseFlashData(this.schoolChose.page);
              this.dialogSet.show = false;
            })
            .catch((err) => {
              this.$message.error(err.message);
            }).finally(() => {
            this.dialogSet.loading = false;
          });
        } else {
          this.dialogSet.show = false;
        }
      },
      // 修改课件权限
      switchCourseMake(row) {
        const clients_course_make_status = {
          clients_course_make_status: row.clients_course_make_status === 1 ? 2 : 1,
        };
        this.$confirm('确定修改课件权限吗', '确认', {
          showCancelButton: true,
          type: 'success',
          confirmButtonText: '确定',
          confirmButtonClass: 'el-button--success',
        })
          .then(() => {
            this.$http
              .patch(`/api/service/operate/clients/${row.id}/clients_course_make_status`, clients_course_make_status)
              .then(() => {
                this.$message.success('状态修改成功');
                this.schoolChoseFlashData(this.schoolChose.page);
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          });
      },
      // 修改录制权限
      switchCourseRecord(row) {
        const clients_record_status = {
          clients_record_status: row.clients_record_status === 1 ? 2 : 1,
        };
        this.$confirm('确定修改录制权限吗', '确认', {
          showCancelButton: true,
          type: 'success',
          confirmButtonText: '确定',
          confirmButtonClass: 'el-button--success',
        })
          .then(() => {
            this.$http
              .patch(`/api/service/operate/clients/${row.id}/clients_record_status`, clients_record_status)
              .then(() => {
                this.$message.success('状态修改成功');
                this.schoolChoseFlashData(this.schoolChose.page);
              })
              .catch((err) => {
                this.$message.error(err.data.message);
              });
          });
      },
      // 修改练习权限
      switchCourseExercise(row) {
        const clients_imkid_exercise_status = {
          clients_imkid_exercise_status: row.clients_imkid_exercise_status === 1 ? 2 : 1,
        };
        this.$confirm('确定修改练习权限吗', '确认', {
          showCancelButton: true,
          type: 'success',
          confirmButtonText: '确定',
          confirmButtonClass: 'el-button--success',
        })
          .then(() => {
            this.$http
              .patch(`/api/service/operate/clients/${row.id}/clients_imkid_exercise_status`, clients_imkid_exercise_status)
              .then(() => {
                this.$message.success('状态修改成功');
                this.schoolChoseFlashData(this.schoolChose.page);
              })
              .catch((err) => {
                this.$message.error(err.data.message);
              });
          });
      },
      // 小程序按钮
      setWechat(row) {
        this.dialogWechat.loading = true;
        this.dialogWechat.show = true;

        this.$http
          .get(`/api/clients/${row.id}/watch-app-id`)
          .then(res => {
            this.dialogWechat.forms.id = row.id;
            this.dialogWechat.isRelevance = !!res.data;
          })
          .catch((err) => {
            this.$message.error(err.data.message);
            this.dialogWechat.show = false;
          })
          .finally(() => {
            this.dialogWechat.loading = false;
          });
      },
      // 关联小程序
      submitWechat() {
        const data = {
          wechat_app_id: this.dialogWechat.forms.mark
        };

        this.dialogWechat.loading = true;

        this.$http
          .patch(`/api/service/operate/clients/${this.dialogWechat.forms.id}/map-wechat-app-id`, data)
          .then(res => {
            this.dialogWechat.show = true;
            this.$message.success("关联成功！")
            this.schoolChoseFlashData(this.schoolChose.page);
            this.dialogWechat.show = false;
          })
          .catch((err) => {
            this.$message.error(err.data.message);
          })
          .finally(() => {
            this.dialogWechat.loading = false;
          });
      },

      // 授权课包 - 显示
      getAuthClass (row) {
        this.authClass.title = `${row.review_used.name}校区课包选择`;
        this.authClass.id = row.id;
        // equal[open_school_select]=1&
        this.authClass.api = `/api/course/commodities?order[id]=desc&open_school_id=${row.id}&equal[status]=1`;

        if (!this.stage_tag_list.length) {
          this.$http.get(`/api/tags?order[order]=desc&equal[type]=stage`).then(res => this.stage_tag_list = res.items);
        }

        if (!this.subject_tag_list.length) {
          this.$http.get(`/api/tags?order[order]=desc&equal[type]=subject`).then(res => this.subject_tag_list = res.items);
        }

        this.authClass.show = true;
      },

      pageCall (obj) {
        obj.page && (this.authClass.page = obj.page);
        obj.per_page && (this.authClass.per_page = obj.per_page);
        this.searchCall();
      },

      // 授权课包 - 搜索
      searchCall (arr) {
        this.authClass.loading = true;

        if (arr) {
          this.authClass.page = 1;
          this.authClass.search = arr;
        } else {
          arr = [];
        }

        console.log(this.authClass.search, '....')

        arr = arr.concat([`page:${this.authClass.page}`, `per_page:${this.authClass.per_page}`, 'order[id]:desc'], this.authClass.search);

        this.$http.get(`${this.authClass.api}&${arr.join('&').replace(/:/g, '=')}`).then(res => {
          this.authClass.list = res;
        }).finally(() => {
          this.authClass.loading = false;
        });
      },

      // 授权课包 - 课程勾选
      GoodsCheck (val, item) {
        this.authClass.loading = true;

        if (item.school_ids.includes(this.authClass.id)) {
          this.$http.delete('/api/course/commodities/open_school', {
            data: {
              commodities_id: item.id,
              school_id: this.authClass.id,
            }
          }).then(() => {
            this.searchCall();
          }).catch(() => {
            this.authClass.loading = false;
          });
        } else {
          this.$http.post('/api/course/commodities/open_school_batch', {
            commodities_id: item.id,
            school_ids: [this.authClass.id],
          })
            .then(() => {
              this.searchCall();
            })
            .catch(() => {
              this.authClass.loading = false;
            });
        }
      },

      // 批量移动
      moreMove (_id) {
        this.moves.form = [{
          attr: 'cascader',
          name: '目录选择',
          width: '80px',
          options: this.typeSelectDataMe[0].childrens,
          props: {
            rules: {
              message: '请选择目录',
              required: true,
              target: 'blur'
            }
          },
          type: 'cascader',
          value: ''
        }];

        this.moves.data = _id;
        this.moves.show = true;
      },
      onMovesForm (valid, data) {
        this.moves.isSubmit = false;

        if (valid) {
          this.$http.patch(`/api/service/operate/clients/${this.moves.data}/school_category_ids`, {
            category_ids: [data.model_cascader[data.model_cascader.length - 1]]
          }).then(() => {
            this.moves.show = false;
            this.$message.success('移动成功');
          });
        }
      },

      // 显示视频
      showVideo (name, src) {
        this.videoData.title = name;
        this.videoData.src = src;
        this.videoData.show = true;
      },

      // 播放视频
      videoOpen () {
        this.$refs.ref_video.play();
      },

      // 关闭视频
      videoClose () {
        this.$refs.ref_video.pause();
      },

      schoolChosePreChange () {
        this.schoolChose.preSelect.isTel && (this.schoolChose.preSelect.value = this.schoolChose.preSelect.value.replace(/[^\d]/g, '').slice(0, 11));
      },

      // 设置会员等级
      setMembershipLevels(row) {
        this.dialogLevel.id = row.id;
        this.dialogLevel.name = row.review_used.name;
        this.dialogLevel.level = row.vip;
        this.dialogLevel.date = row.vip_start_at ? [row.vip_start_at, row.vip_end_at] : [];
        this.dialogLevel.dates = Object.assign([], this.dialogLevel.date);
        this.dialogLevel.created_at = (new Date(row.created_at)).getTime() + (15 * 24 * 60 * 60 * 1000);
        this.dialogLevel.show = true;
      },
      dialogLevelSubmit() {
        const obj = {
          vip: this.dialogLevel.level,
        };

        if (this.dialogLevel.date.length) {
          obj.vip_start_at = this.dialogLevel.date[0].split(' ')[0] + ' 00:00:00';
          obj.vip_end_at = this.dialogLevel.date[1].split(' ')[0] + ' 23:59:59';
        } else if (this.dialogLevel.level > 0) {
          this.$message.warning('请选择有效日期');
          return;
        }

        this.dialogLevel.loading = true;

        this.$http.patch(`/api/service/operate/clients/${this.dialogLevel.id}/vip`, obj).then(() => {
          this.dialogLevel.show = false;
          this.$message.success('设置成功');
          this.reload();
        }).finally(() => {
          this.dialogLevel.loading = false;
        });
      },
      // 练习收费配置
      practiceFeeConfiguration(row) {
        this.dialogFee.id = row.id;
        this.dialogFee.name = row.review_used.name;
        this.dialogFee.show = true;
        this.dialogFee.loading = true;

        this.$http.get(`api/student/exercise/price?clients_id=${row.id}`).then(res => {
          this.dialogFee.coin = res.data.price;
          this.dialogFee.loading = false;
        });
      },
      dialogFeeSubmit() {
        this.dialogFee.loading = true;

        this.$http.patch(`api/service/operate/clients/${this.dialogFee.id}/options/charge_school`, {
          student_exercise: this.dialogFee.coin,
        }).then(() => {
          this.dialogFee.show = false;
          this.$message.success('设置成功');
          this.reload();
        }).finally(() => {
          this.dialogFee.loading = false;
        });
      },
      dialogFeeInput() {
        // this.dialogFee.coin = ~~(this.dialogFee.coin.replace(/[^\d]/g, ''));
        this.dialogFee.coin = parseFloat(this.dialogFee.coin)
      },

      changeLevel() {
        if ((new Date(this.dialogLevel.date[0])).getTime() < this.dialogLevel.created_at) {
          this.dialogLevel.date = Object.assign([], this.dialogLevel.dates);
          this.$message.warning('开始日期要大于创建日期+15天');
        } else {
          this.dialogLevel.dates = Object.assign([], this.dialogLevel.date);
        }
      },
    },
    computed: {
      selectWidth() {
        const maxLength = Math.max(
          ...this.schoolChose.preSelect.option.map(({ label }) => label.length),
        );

        return `${maxLength + 4}em`;
      },
      searchArr() {
        return [
          {
            selectValue: [
              {
                value: 2,
                name: '下架中'
              },
              {
                value: 1,
                name: '上架中'
              },
            ],
            componentType: 'AppSearchStatus',
            searchType: 'status',
            placeholder: ''
          },
          {
            selectValue: this.stage_tag_list ? this.stage_tag_list.map((item) => {
              return { value: item.id, name: item.name }
            }) : [],
            componentType: 'AppSearchStatus',
            searchType: 'stage_tag_id',
            placeholder: ''
          },
          {
            selectValue: this.subject_tag_list ? this.subject_tag_list.map((item) => {
              return { value: item.id, name: item.name }
            }) : [],
            componentType: 'AppSearchStatus',
            searchType: 'subject_tag_id',
            placeholder: ''
          },
          {componentType: 'AppSearchColumn', searchType: [
              { prop: 'name', label: '商品名称' },
              { prop: 'code', label: '编码搜索' },
              { prop: 'search_school_name', label: '制作校区' },
              { prop: 'search_open_school', label: '开放校区' },
            ]},
        ];
      },
      authClassAttr() {
        return [
          {
            selectValue: [
              {
                value: 1,
                name: '已选'
              },
              {
                value: 0,
                name: '未选'
              },
            ],
            componentType: 'AppSearchStatus',
            searchType: 'open_school_select',
            placeholder: '请选择类型'
          },
          {
            componentType: 'AppSearchColumn',
            searchType: [
              { prop: 'open_school_name', label: '校区名称' },
              { prop: 'open_school_mobile', tel: true, label: '手机号' },
            ],
            label: '已开放校区',
          },
          {
            selectValue: this.stage_tag_list ? this.stage_tag_list.map((item) => {
              return { value: item.id, name: item.name }
            }) : [],
            componentType: 'AppSearchStatus',
            searchType: 'stage_tag_id',
            label: '学生年级',
          },
          {
            selectValue: this.subject_tag_list ? this.subject_tag_list.map((item) => {
              return { value: item.id, name: item.name }
            }) : [],
            componentType: 'AppSearchStatus',
            searchType: 'subject_tag_id',
            label: '学生科目',
          },
          {
            componentType: 'AppSearchColumn',
            searchType: 'name',
            placeholder: '搜索商品名称'
          },
        ];
      },
    },
    watch: {
      'schoolChose.preSelect.attr' (val) {
        this.schoolChose.preSelect.isTel = false;

        this.schoolChose.preSelect.option.forEach(item => {
          if (item.value === val && item.tel) {
            this.schoolChose.preSelect.isTel = true;
          }
        });

        this.$set(this.schoolChose.preSelect, 'value', '');
      }
    }
  }
</script>

<style scoped lang="scss">
  .opt-btn {
    margin: 0 10px 10px 0;
  }

  .form_img {
    width: 100px;
    height: 100px;
  }

  .dis-event, .dis-some {
    /deep/ .is-delete,
    /deep/ .w-e-text,
    /deep/ .app-text-area__tool,
    /deep/ .app-upload-scale__block {
      pointer-events: none;
    }

    /deep/ .app-text-area__text {
      overflow-y: scroll;
    }
    /deep/ .w-e-text {
      overflow-y: initial;
    }
  }
  .dis-event .school-all {
    pointer-events: none;
  }

  .headimgurl /deep/ .app-upload-scale__block img {
    height: 100%;
    object-fit: contain;
  }

  .area-detail {
    /deep/ .app-text-area__text,
    /deep/ .app-text-area__tool {
      border: 1px solid #DCDFE6;
      border-radius: 4px 4px 0 0;
    }
    /deep/ .app-text-area__text {
      height: 300px;
      border-top: none;
      border-radius: 0 0 4px 4px;
    }
  }

  .dis-some {
    pointer-events: none;
    /deep/ .el-input__suffix-inner {
      pointer-events: none;
    }

    .allow-some {
      pointer-events: auto;

      /deep/ .el-input__suffix-inner {
        pointer-events: auto;
      }
    }
  }

  .school-all {
    float: right;
    padding: 0 10px;
    cursor: pointer;
  }
  /deep/ .el-input__inner[type=number] {
    padding-right: 0;
  }

  .school-chose {
    /deep/ .el-table__header-wrapper  .el-checkbox {
      display: none;
    }
  }

  .level-date-style {
    width: 200px;
    padding: 0 5px;

    /deep/ .el-icon-date,
    /deep/ .el-input__icon {
      display: none;
    }
    /deep/ .el-range-input {
      width: 48%;
    }
    /deep/ .el-range-separator {
      width: auto;
      line-height: 40px;
      padding: 0;
    }
  }
  .style-fee {
    padding-left: 50px;

    /deep/ .el-input {
      width: 50px;

      input {
        padding: 0;
        text-align: center;
      }
    }
  }
</style>
<style scoped lang="scss">
  .select-check {
    position: absolute;
    bottom: 9px;
    right: 10px;
    height: 23px;
    overflow: hidden;

    /deep/ .el-checkbox__inner {
      width: 23px;
      height: 23px;
      cursor: default;

      &:after {
        height: 10px;
        left: 9px;
        top: 4px;
      }
    }
  }
</style>
<style scoped lang="scss">
  @import '@/assets/reset.scss';
  @import "../CampusManagement/list/goods.scss";
</style>



// WEBPACK FOOTER //
// src/views/Goods/index.vue